<div class="o-grid">
	<div class="o-grid__cell o-grid__cell--w-100">
		<div class="c-card">
			<div class="c-content c-content--xxl">
				<div class="o-grid o-grid--wrap o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p" [ngSwitch]="vm.status">
						<p id="bookingSuccessMessage" class="c-text c-text--center c-text--xl u-ost-xxl u-osb-xl" *ngSwitchCase="'success'">{{ 'Booking.Booking_Successful' | translate }}</p>
						<p id="bookingErrorMessage" class="c-text c-text--center c-text--s7 c-text--s8 u-ost-xxl u-osb-xl" *ngSwitchCase="'error'">{{ 'Booking.Errored' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<a id="bookingCheckoutFinishedBackButton" href="" class="c-button c-button--s2 c-button--lg u-osb-xxl">{{ 'Booking.Back_To_Main' | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
